import { MQ } from '@/lib/breakpoints';
import { useMediaQuery } from './useMediaQuery';

/**
 * True at <=767px (phone layout — sidebar in drawer, mobile header). ≥768px is
 * the desktop tier; there is no intermediate compact/tablet tier (PDR 008 D3,
 * amended 2026-06-12: strict two-tier 767/768 model).
 *
 * Use for behavioral changes (conditional rendering, logic). For styling, prefer
 * CSS @media (max-width: 767px) / (min-width: 768px) queries directly.
 */
export const useIsCompactLayout = (): boolean => useMediaQuery(MQ.compact);
